// extracted by mini-css-extract-plugin
export default {"modal":"tooltipModal_modal__+ACAp","modalWrapper":"tooltipModal_modalWrapper__1FvUO","buttonWidth":"tooltipModal_buttonWidth__fmEOV","infoIcon":"tooltipModal_infoIcon__A4O10"};